import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '@components/loader/1'
import { ElementHTML } from '@helpers/helper.rendering'

const AboutUs_9 = (props: RealEstateDataPageComponentData) => {
  const { title, paragraphs, subtitle, subtitleElement, height, myConfig } = props
  const [load, setLoad] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 0)
  }, [])

  return (
    <section className="about-section-text p-y-config">
      {!load ? (
        <>
          <Container
            fluid
            style={{
              height: screen.width < 992 ? height?.mobile ?? 'auto' : height?.desktop ?? 'auto',
            }}
            className={`${myConfig ? 'w-75 d-flex align-items-center' : ''}`}
          >
            <Row>
              {title ? (
                <Col
                  xs={12}
                  lg={6}
                >
                  <div
                    className={`title text-lg-start mb-5 mb-lg-0 ${
                      myConfig ? 'text-start' : 'text-center'
                    }`}
                  >
                    {title.split('\n').map((titl, index) => (
                      <h2
                        className="me-3 d-inline-block"
                        key={index}
                      >
                        {titl}
                      </h2>
                    ))}
                  </div>
                  {subtitle && (
                    <ElementHTML
                      children={subtitle || ''}
                      elementType={subtitleElement || 'h5'}
                      className={`text-lg-start mb-5 mb-lg-0 mt-lg-3 ${
                        myConfig ? 'text-start' : 'text-center'
                      }`}
                    />
                  )}
                </Col>
              ) : null}
              {paragraphs && paragraphs?.length > 0 ? (
                <Col
                  xs={12}
                  lg={6}
                >
                  <div
                    className={`text-wrapper d-flex flex-column text-lg-start ${
                      myConfig ? 'text-start' : 'text-center'
                    }`}
                  >
                    {paragraphs?.map((p, i) => (
                      <p
                        className="mb-3"
                        key={i}
                      >
                        {p}
                      </p>
                    ))}
                  </div>
                </Col>
              ) : null}
            </Row>
          </Container>
        </>
      ) : (
        <Loader />
      )}
    </section>
  )
}

export default AboutUs_9
